/* Casa Lume — scripts do tema
   Cada seção é iniciada por initAll(contexto). No editor da Shopify, quando uma
   seção é recarregada (ao mudar cor, texto etc.), ela é iniciada de novo. */
(function () {
  'use strict';

  var CL = window.CasaLume || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  function once(el, key) {
    if (el.getAttribute('data-cl-' + key)) return false;
    el.setAttribute('data-cl-' + key, '1');
    return true;
  }

  /* ---------- Dinheiro ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || CL.moneyFormat || 'R$ {{amount_with_comma_separator}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || '.';
      decimal = typeof decimal === 'undefined' ? ',' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = fmt.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount_with_comma_separator') {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, '.', ',');
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2600);
  }

  /* ---------- Gavetas (menu e carrinho) ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var drawer = document.getElementById(id);
    var overlay = $('[data-drawer-overlay="' + id + '"]');
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { drawer.focus(); }, 50);
  }
  function closeDrawer(id) {
    var drawer = document.getElementById(id);
    var overlay = $('[data-drawer-overlay="' + id + '"]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); openDrawer(open.getAttribute('data-drawer-open')); return; }
    var close = t.closest('[data-drawer-close]');
    if (close) { e.preventDefault(); closeDrawer(close.getAttribute('data-drawer-close')); return; }
    var overlay = t.closest('[data-drawer-overlay]');
    if (overlay) { closeDrawer(overlay.getAttribute('data-drawer-overlay')); return; }
    var cartOpen = t.closest('[data-cart-open]');
    if (cartOpen && CL.afterAdd === 'drawer' && document.getElementById('CartDrawer') && !document.body.classList.contains('template-cart')) {
      e.preventDefault(); openDrawer('CartDrawer'); return;
    }
    var searchOpen = t.closest('[data-search-open]');
    if (searchOpen) { openSearch(); return; }
    if (t.closest('[data-search-close]')) { closeSearch(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(function (d) { closeDrawer(d.id); });
    closeSearch();
  });

  /* ---------- Busca ---------- */
  function openSearch() {
    var m = $('#SearchModal');
    if (!m) return;
    m.hidden = false;
    var input = $('[data-predictive-input]', m);
    if (input) input.focus();
  }
  function closeSearch() {
    var m = $('#SearchModal');
    if (m && !m.hidden) m.hidden = true;
  }
  var searchTimer;
  document.addEventListener('input', function (e) {
    var searchInput = e.target.closest('[data-predictive-input]');
    if (!searchInput || !CL.routes || !CL.routes.predictive_search_url) return;
    clearTimeout(searchTimer);
    var q = searchInput.value.trim();
    var box = $('[data-predictive-results]');
    if (!box) return;
    if (q.length < 2) { box.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      fetch(CL.routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) { box.innerHTML = '<p>Nada encontrado para "' + q.replace(/</g, '&lt;') + '".</p>'; return; }
          box.innerHTML = products.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=120" alt="" loading="lazy">' : '';
            return '<a href="' + p.url + '">' + img + '<span><strong>' + p.title + '</strong><br>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
          }).join('');
        })
        .catch(function () {});
    }, 220);
  });

  /* ---------- Cabeçalho (procura o cabeçalho a cada rolagem, então funciona após recarregar) ---------- */
  function onScroll() {
    var header = $('[data-header]');
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Barra de avisos ---------- */
  function initAnnouncements(ctx) {
    $$('[data-announcement]', ctx).forEach(function (bar) {
      if (!once(bar, 'ann')) return;
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0;
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === 0); });
      var ms = (parseInt(bar.getAttribute('data-interval'), 10) || 5) * 1000;
      bar._clTimer = setInterval(function () {
        if (!document.contains(bar)) { clearInterval(bar._clTimer); return; }
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, ms);
    });
  }

  /* ---------- Contagem regressiva ---------- */
  function initCountdowns(ctx) {
    $$('[data-countdown]', ctx).forEach(function (el) {
      if (!once(el, 'cd')) return;
      var target = new Date(el.getAttribute('data-target')).getTime();
      if (isNaN(target)) return;
      var d = $('[data-cd="d"]', el), h = $('[data-cd="h"]', el), m = $('[data-cd="m"]', el), sEl = $('[data-cd="s"]', el);
      if (!d || !h || !m) return;
      function tick() {
        if (!document.contains(el)) { clearInterval(el._clTimer); return; }
        var diff = Math.max(0, target - Date.now());
        d.textContent = Math.floor(diff / 86400000);
        h.textContent = String(Math.floor((diff % 86400000) / 3600000)).padStart(2, '0');
        m.textContent = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
        if (sEl) sEl.textContent = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
      }
      tick();
      el._clTimer = setInterval(tick, sEl ? 1000 : 30000);
    });
  }

  /* ---------- Carrinho ---------- */
  /* Depois de adicionar: 'page' vai para o carrinho, 'checkout' vai direto para o checkout
     (o checkout externo assume em /cart?skipCart=1), 'drawer' abre o carrinho lateral. */
  function goAfterAdd() {
    var mode = CL.afterAdd || 'drawer';
    if (mode === 'drawer') return false;
    var url = CL.routes.cart_url + (mode === 'checkout' ? '?skipCart=1' : '');
    window.location.href = url;
    return true;
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCartDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawer');
        var current = document.getElementById('CartDrawer');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });
  }

  function changeLine(line, qty) {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.add('is-loading');
    return fetch(CL.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return refreshCartDrawer(); })
      .finally(function () { if (drawer) drawer.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn || !btn.closest('#CartDrawer')) return;
    e.preventDefault();
    changeLine(parseInt(btn.getAttribute('data-qty-change'), 10), parseInt(btn.getAttribute('data-qty'), 10));
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input || !input.closest('#CartDrawer')) return;
    changeLine(parseInt(input.getAttribute('data-qty-input'), 10), parseInt(input.value, 10) || 0);
  });

  function addToCart(form, button) {
    var errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.hidden = true;
    var original = button.textContent;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = CL.strings.adding;
    var fd = new FormData(form);
    return fetch(CL.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Erro ao adicionar');
        return fetch(CL.routes.cart_url + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (goAfterAdd()) return;
        return refreshCartDrawer().then(function () {
          if (document.getElementById('CartDrawer')) openDrawer('CartDrawer');
          else toast(CL.strings.added);
        });
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else toast(err.message);
      })
      .finally(function () {
        button.removeAttribute('aria-disabled');
        button.textContent = original;
      });
  }

  /* ---------- Página de produto ---------- */
  function initProducts(ctx) {
    $$('[data-product-section]', ctx).forEach(function (section) {
      if (!once(section, 'product')) return;
      var jsonEl = $('[data-product-json]', section);
      if (!jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
      var form = $('form[data-product-form]', section);
      var idInput = form ? $('[data-variant-id]', form) : null;
      var addBtn = form ? $('[data-add-button]', form) : null;

      /* Galeria */
      var slides = $$('.gallery__slide', section);
      var thumbs = $$('[data-thumb]', section);
      function showMedia(mediaId) {
        var found = false;
        slides.forEach(function (s) {
          var on = String(s.getAttribute('data-media-id')) === String(mediaId);
          s.classList.toggle('is-active', on);
          if (on) found = true;
        });
        if (!found && slides[0]) slides[0].classList.add('is-active');
        thumbs.forEach(function (t) {
          var on = String(t.getAttribute('data-thumb')) === String(mediaId);
          t.setAttribute('aria-current', on ? 'true' : 'false');
          if (on && t.parentNode) {
            var box = t.parentNode;
            box.scrollTo({ left: t.offsetLeft - box.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
          }
        });
      }
      function step(dir) {
        var idx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        var next = slides[(idx + dir + slides.length) % slides.length];
        if (next) showMedia(next.getAttribute('data-media-id'));
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
      var prev = $('[data-gallery-prev]', section), nextBtn = $('[data-gallery-next]', section);
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
      var main = $('.gallery__main', section);
      if (main) {
        var startX = null;
        main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
          startX = null;
        });
      }

      /* Variantes */
      function selectedOptions() {
        var opts = [];
        $$('[data-variant-picker] fieldset', section).forEach(function (fs, i) {
          var checked = $('input:checked', fs);
          opts[i] = checked ? checked.value : null;
        });
        return opts;
      }
      function findVariant(opts) {
        return product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }
      function updatePrice(v) {
        var priceBox = $('[data-price]', section);
        if (!priceBox) return;
        var current = $('[data-price-current]', priceBox);
        var compare = $('[data-price-compare]', priceBox);
        var save = $('[data-price-save]', priceBox);
        var inst = $('[data-price-installments]', priceBox);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (current) current.textContent = formatMoney(v.price);
        priceBox.classList.toggle('price--sale', !!onSale);
        if (compare) {
          compare.hidden = !onSale;
          if (onSale) compare.innerHTML = '<span class="visually-hidden">Preço original</span>' + formatMoney(v.compare_at_price);
        }
        if (save) {
          save.hidden = !onSale;
          if (onSale) save.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% de desconto';
        }
        if (inst) {
          var n = parseInt(inst.getAttribute('data-installments'), 10);
          if (n > 0) inst.textContent = 'ou ' + n + 'x de ' + formatMoney(Math.floor(v.price / n)) + ' sem juros';
        }
        var sticky = $('[data-sticky-price]', section);
        if (sticky) sticky.textContent = formatMoney(v.price);
      }
      function onVariantChange() {
        var opts = selectedOptions();
        opts.forEach(function (val, i) {
          var label = $('[data-option-label="' + i + '"]', section);
          if (label) label.textContent = val;
        });
        var v = findVariant(opts);
        if (!addBtn) return;
        if (!v) {
          addBtn.disabled = true;
          addBtn.textContent = CL.strings.unavailable;
          return;
        }
        idInput.value = v.id;
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? CL.strings.addToCart : CL.strings.soldOut;
        updatePrice(v);
        if (v.featured_media) showMedia(v.featured_media.id);
        if (!window.Shopify || !window.Shopify.designMode) {
          var url = section.getAttribute('data-url') + '?variant=' + v.id;
          window.history.replaceState({}, '', url);
        }
      }
      $$('[data-variant-picker] input', section).forEach(function (input) {
        input.addEventListener('change', onVariantChange);
      });

      /* Quantidade */
      $$('[data-qty-step]', section).forEach(function (b) {
        b.addEventListener('click', function () {
          var field = $('[data-qty-field]', section);
          if (!field) return;
          var val = (parseInt(field.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10);
          field.value = Math.max(1, val);
        });
      });

      /* Adicionar ao carrinho */
      if (form && addBtn) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return;
          addToCart(form, addBtn);
        });
      }

      /* Botão fixo no celular */
      var sticky = $('[data-sticky-atc]', section);
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
          var sb2 = $('[data-sticky-add]', sticky);
          if (sb2) sb2.tabIndex = visible ? 0 : -1;
        });
        io.observe(addBtn);
        section._clObserver = io;
        var sb = $('[data-sticky-add]', sticky);
        if (sb) sb.addEventListener('click', function () {
          if (addBtn.disabled) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          addToCart(form, addBtn);
        });
      }

      /* Previsão de entrega em dias úteis */
      var delivery = $('[data-delivery]', section);
      var deliveryText = delivery ? $('[data-delivery-text]', delivery) : null;
      if (deliveryText) {
        var addBusinessDays = function (date, n) {
          var d = new Date(date);
          var guard = 0;
          while (n > 0 && guard < 400) {
            d.setDate(d.getDate() + 1);
            var wd = d.getDay();
            if (wd !== 0 && wd !== 6) n--;
            guard++;
          }
          return d;
        };
        var fmt = function (d) { return d.toLocaleDateString('pt-BR', { day: 'numeric', month: 'short' }).replace('.', ''); };
        var min = parseInt(delivery.getAttribute('data-min'), 10) || 0;
        var max = parseInt(delivery.getAttribute('data-max'), 10) || min;
        var today = new Date();
        deliveryText.innerHTML = 'Previsão de entrega: <strong>' + fmt(addBusinessDays(today, min)) + ' a ' + fmt(addBusinessDays(today, max)) + '</strong>';
      }
    });
  }

  /* ---------- Adicionar direto do card ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.card__quick');
    if (!form) return;
    e.preventDefault();
    var btn = $('[data-add-button]', form);
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    var label = btn.innerHTML;
    btn.setAttribute('aria-disabled', 'true');
    var fd = new FormData(form);
    fetch(CL.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || 'Erro ao adicionar');
        return fetch(CL.routes.cart_url + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (goAfterAdd()) return;
        return refreshCartDrawer().then(function () {
          if (document.getElementById('CartDrawer')) openDrawer('CartDrawer'); else toast(CL.strings.added);
        });
      })
      .catch(function (err) { toast(err.message); })
      .finally(function () { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; });
  });

  /* ---------- Carrossel (avaliações e afins) ---------- */
  var carousels = [];
  function initCarousels(ctx) {
    $$('[data-carousel]', ctx).forEach(function (root) {
      if (!once(root, 'carousel')) return;
      var track = $('[data-carousel-track]', root);
      if (!track) return;
      var prev = $('[data-carousel-prev]', root), next = $('[data-carousel-next]', root);
      var dotsBox = $('[data-carousel-dots]', root);
      function stepSize() {
        var first = track.children[0];
        if (!first) return track.clientWidth || 1;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return (first.getBoundingClientRect().width + gap) || 1;
      }
      function pages() { return Math.min(50, Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / stepSize()) + 1)); }
      function current() { return Math.round(track.scrollLeft / stepSize()); }
      function update() {
        var c = current();
        if (dotsBox) $$('button', dotsBox).forEach(function (b, i) { b.classList.toggle('is-active', i === c); });
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      function buildDots() {
        if (!dotsBox) { update(); return; }
        var n = track.scrollWidth > track.clientWidth + 4 ? pages() : 0;
        dotsBox.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.tabIndex = -1;
          b.setAttribute('aria-label', 'Ir para ' + (i + 1));
          (function (idx) { b.addEventListener('click', function () { track.scrollTo({ left: idx * stepSize(), behavior: 'smooth' }); }); })(i);
          dotsBox.appendChild(b);
        }
        update();
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: 'smooth' }); });
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      carousels.push({ root: root, build: buildDots });
      buildDots();
    });
  }
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      carousels = carousels.filter(function (c) { return document.contains(c.root); });
      carousels.forEach(function (c) { c.build(); });
    }, 150);
  });

  /* ---------- Copiar cupom ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-copy');
    var done = function () {
      var tag = $('[data-copied]', btn);
      if (tag) { tag.hidden = false; setTimeout(function () { tag.hidden = true; }, 1800); }
    };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done).catch(done); else done();
  });

  /* ---------- Recomendações ---------- */
  function initRecommendations(ctx) {
    $$('[data-recommendations]', ctx).forEach(function (el) {
      if (!once(el, 'recs')) return;
      if (el.children.length && el.querySelector('.grid')) return;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; el.className = fresh.className; }
        })
        .catch(function () {});
    });
  }

  /* ---------- Iniciar tudo ---------- */
  function initAll(ctx) {
    var steps = [initAnnouncements, initCountdowns, initProducts, initCarousels, initRecommendations];
    steps.forEach(function (fn) {
      try { fn(ctx || document); } catch (err) { if (window.console) console.warn('[Casa Lume]', err); }
    });
    onScroll();
  }
  initAll(document);

  /* Editor de temas: reinicia a seção recarregada e limpa a que saiu */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-countdown], [data-announcement]', e.target).forEach(function (el) { if (el._clTimer) clearInterval(el._clTimer); });
    $$('[data-product-section]', e.target).forEach(function (el) { if (el._clObserver) el._clObserver.disconnect(); });
    if (document.body.style.overflow === 'hidden' && !$('.drawer.is-open')) document.body.style.overflow = '';
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target;
    var track = item && item.closest('[data-carousel-track]');
    if (track) track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  });
})();
